<template>
  <div>
    <v-btn
      small
      fab
      :title="tags.length ? tags.join(', ') : 'More filters'"
      @click="openFilters"
    >
      <v-icon small>fal fa-filter</v-icon>
    </v-btn>

    <v-dialog
      transition="dialog-bottom-transition"
      scrollable
      max-width="480"
      v-model="modalOpen"
    >
      <v-card>
        <v-card-title class="headline grey lighten-2 text-xs-center" primary-title>
          Extra Filters
        </v-card-title>
        <v-card-text>
          <v-switch
            v-model="localFilters.hasAudio"
            label="Show only stops with attached audio"
            color="primary"
            hide-details
            class="mt-0"
          />
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-btn color="warning" flat @click="modalOpen = false">Cancel</v-btn>
          <v-spacer />
          <v-btn flat @click="clearFilters" :disabled="!tags.length && !localFilters.hasAudio">Clear</v-btn>
          <v-btn color="primary" @click="applyFilters">Filter</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import src from './src'
export default src
</script>
